import React, { Component } from "react";
import AntdAffix, {AffixProps} from 'antd/lib/affix';
import 'antd/lib/affix/style';

export default class Affix extends Component<AffixProps> {
    render() {
        return (
          <AntdAffix {...this.props} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/affix/index.tsx